// extracted by mini-css-extract-plugin
export default {"card":"EntitiesInfoCard_card__4o1T8","iconWrapper":"EntitiesInfoCard_iconWrapper__901pi"};